/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Detail_GroupsInputs */

const en_audit_detail_groups = /** @type {(inputs: Audit_Detail_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups`)
};

const pt_br2_audit_detail_groups = /** @type {(inputs: Audit_Detail_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos`)
};

/**
* | output |
* | --- |
* | "Groups" |
*
* @param {Audit_Detail_GroupsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_detail_groups = /** @type {((inputs?: Audit_Detail_GroupsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Detail_GroupsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_detail_groups(inputs)
	return pt_br2_audit_detail_groups(inputs)
});